/** @type {import('../help-index.js').HelpScreen} */
export const MET_PRO_HELP = {
  screenId: 'met-pro',
  label: 'Producción',
  navPath: 'Métricas → Producción',
  keywords: ['producción', 'métricas producción'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Módulo en desarrollo.',
  sidebarItems: [{
    id: 'pro',
    screenId: 'met-pro',
    label: 'Producción',
    description: 'Próximamente.',
    detail: {
      sections: [{ title: 'Estado', paragraphs: ['Esta sección aún no está disponible en el sistema.'] }],
    },
  }],
}

/** @type {import('../help-index.js').HelpScreen} */
export const MET_BOA_HELP = {
  screenId: 'met-boa',
  label: 'Tablero de Control',
  navPath: 'Métricas → Tablero de Control',
  keywords: ['dashboard', 'tablero', 'control'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Módulo en desarrollo.',
  sidebarItems: [{
    id: 'boa',
    screenId: 'met-boa',
    label: 'Tablero',
    description: 'Próximamente.',
    detail: {
      sections: [{ title: 'Estado', paragraphs: ['El tablero de control central aún no está disponible.'] }],
    },
  }],
}
